import { render, staticRenderFns } from "./clinicaltwo.vue?vue&type=template&id=f9287f8a&scoped=true"
import script from "./clinicaltwo.vue?vue&type=script&lang=js"
export * from "./clinicaltwo.vue?vue&type=script&lang=js"
import style0 from "./clinicaltwo.vue?vue&type=style&index=0&id=f9287f8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9287f8a",
  null
  
)

export default component.exports